import React from 'react';
import 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui-primitive/separator/separator.scss';

type Orientation = 'horizontal' | 'vertical';

export interface RichTextSeparatorProps
  extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: Orientation;
  decorative?: boolean;
}

export const RichTextSeparator = React.forwardRef<
  HTMLDivElement,
  RichTextSeparatorProps
>(
  (
    { decorative, orientation = 'vertical', className = '', ...divProps },
    ref,
  ) => {
    const ariaOrientation =
      orientation === 'vertical' ? orientation : undefined;
    const semanticProps = decorative
      ? { role: 'none' }
      : { 'aria-orientation': ariaOrientation, role: 'separator' };

    return (
      <div
        className={`tiptap-separator ${className}`.trim()}
        data-orientation={orientation}
        {...semanticProps}
        {...divProps}
        ref={ref}
      />
    );
  },
);

RichTextSeparator.displayName = 'Separator';
